import React, { useEffect, useState } from 'react';
import '../../styles/fightCardV2.1.0/GamePanelNew.scss';

const GamePanelNew = ({
  leftTeam,
  rightTeam,
  leftTeamAcronym,
  rightTeamAcronym,
  selectedTagLabel,
  unselectedTagLabel,
  leftColor,
  rightColor,
  startTime,
  teamSelected,
  onTeamSelect,
  isInteractable = false,
}) => {
  const teams = [
    {
      id: leftTeam,
      acronym: leftTeamAcronym,
      color: leftColor,
    },
    {
      id: rightTeam,
      acronym: rightTeamAcronym,
      color: rightColor,
    },
  ];
  const [expandedSide, setExpandedSide] = useState(null);

  const getContrastYIQ = hexcolor => {
    if (!hexcolor) return 'black';
    const color = hexcolor.replace('#', '');
    const r = parseInt(color.substr(0, 2), 16);
    const g = parseInt(color.substr(2, 2), 16);
    const b = parseInt(color.substr(4, 2), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? 'black' : 'white';
  };

  const getTeamClass = side => (expandedSide === side ? 'expanded' : '');

  const getTimeBoxClass = () => {
    if (expandedSide === 'left') return 'move-right';
    if (expandedSide === 'right') return 'move-left';
    return '';
  };

  const getTagLabel = side => {
    if (!expandedSide) return 'Pick';
    return expandedSide === side ? selectedTagLabel : unselectedTagLabel;
  };

  const getTagClass = side => {
    if (!expandedSide) return 'orange';
    return expandedSide === side ? 'orange' : 'white';
  };

  const getDayText = dateObject => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    if (dateObject.toDateString() === today.toDateString()) {
      return 'Today';
    }
    if (dateObject.toDateString() === tomorrow.toDateString()) {
      return 'Tomorrow';
    }
    return dateObject.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
    });
  };

  const handleSideClick = (e, side) => {
    if (!isInteractable) return;
    e.stopPropagation();
    setExpandedSide(prev => (prev === side ? null : side));
    let newSelectedTeam;
    if (side === 'left') {
      newSelectedTeam = leftTeam;
    } else if (side === 'right') {
      newSelectedTeam = rightTeam;
    } else {
      newSelectedTeam = null;
    }
    onTeamSelect?.(newSelectedTeam);
  };

  useEffect(() => {
    let newSide;
    if (teamSelected === leftTeam) {
      newSide = 'left';
    } else if (teamSelected === rightTeam) {
      newSide = 'right';
    } else {
      newSide = null;
    }
    setExpandedSide(newSide);
  }, [teamSelected, leftTeam, rightTeam]);

  return (
    <div className='fight-container'>
      <div className='teams'>
        {teams.map((team, index) => {
          const side = index === 0 ? 'left' : 'right';
          const textColor = getContrastYIQ(team.color);
          return (
            <div
              key={team.id}
              className={`team ${getTeamClass(side)}`}
              style={{ backgroundColor: team.color, color: textColor }}
              role='button'
              tabIndex={0}
              onClick={e => handleSideClick(e, side)}
              onKeyDown={e => e.key === 'Enter' && handleSideClick(e, side)}>
              <div className='team-wrap'>
                <p className='label' style={{ color: textColor }}>
                  {team.acronym}
                </p>
                {selectedTagLabel && unselectedTagLabel && (
                  <span className={`tag ${getTagClass(side)}`} style={{ color: textColor }}>
                    {getTagLabel(side)}
                  </span>
                )}
              </div>
            </div>
          );
        })}

        <div className={`time-box ${getTimeBoxClass()}`}>
          {startTime ? (
            <>
              <p>{getDayText(startTime)}</p>
              <p>
                {startTime.toLocaleTimeString('en-US', {
                  hour: 'numeric',
                  minute: 'numeric',
                })}
              </p>
            </>
          ) : (
            <p>Versus</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default GamePanelNew;
